import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=6c8f93f5&scoped=true"
import script from "./OptionSelect.vue?vue&type=script&lang=js"
export * from "./OptionSelect.vue?vue&type=script&lang=js"
import style0 from "./OptionSelect.vue?vue&type=style&index=0&id=6c8f93f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f93f5",
  null
  
)

export default component.exports